export function createAfterCursor(currentPage, pageSize) {
    if (currentPage === 1) {
        return null;
    }

    // The cursor is just an base64 encoded string containing the
    // offset counted from zero.
    return btoa(`arrayconnection:${pageSize * (currentPage - 1) - 1}`);
}

export function calculateOffset(afterCursor) {
    if (afterCursor === null || afterCursor === undefined) {
        return 0;
    }
    // If not null: Decode the base64 cursor, result will be something like:
    // 'arrayconnection:9', then split the string on `:`, then grab the second part.
    // The second part will be the offset counted from zero, so we have to add 1 use
    // it in JS slice.
    const decodedString = atob(afterCursor);
    const parts = decodedString.split(':');
    const offset = parseInt(parts[1], 10) + 1;

    return offset;
}
